import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { BaseApiRequest } from "@robe/core-api/baseApiRequest";
import { NotFoundError } from "../errors";

export interface SlugDuplicateResponse {
  contentId: number;
  slug: string;
  locale?: string;
  title: string;
  alias: boolean;
}

export interface IsSlugDuplicateParams {
  slug: string;
  contentType: string;
  contentId?: number;
  locale: string;
}

export const isSlugDuplicate = (core: XcoreCore, params: IsSlugDuplicateParams): BaseApiRequest<SlugDuplicateResponse[]> =>
  core
    .fetch(`/api/route/slugs/duplicate${parseQueryParamsObject(params)}`)
    .then((r) => r.json())
    .catch((err) => {
      if (err instanceof NotFoundError) {
        return [];
      }

      throw err;
    });
